"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var ARROW_GIRTH = 3;
var buttonWithArrowStyles = makeStyles_1.default(function (theme) {
    var _a;
    return ({
        root: (_a = {
                paddingLeft: 20,
                minWidth: '280px',
                maxWidth: 'fit-content',
                pointerEvents: 'auto'
            },
            _a[theme.breakpoints.down('sm')] = {
                minWidth: '250px',
                maxWidth: 'fit-content',
            },
            _a),
        label: {
            fontSize: function (props) {
                return theme.typography.pxToRem(props.labelSize === 'large' ? theme.typography.fontMD : theme.typography.fontSM);
            },
        },
        arrow: {
            '&::after': {
                content: "' '",
                position: 'absolute',
                display: 'block',
                borderStyle: 'solid',
                borderWidth: '3px 0 0 3px',
                borderColor: function (props) {
                    return "" + (!props.disabled ? theme.palette[props.color || 'primary'].main : theme.palette.text.disabled);
                },
                width: function (props) { return props.arrowSize; },
                height: function (props) { return props.arrowSize; },
                top: '50%',
                left: '50%',
                transform: function (props) { return "translate(-50%, -50%) translate(-" + props.arrowSize / 5 + "px, 0) rotate(135deg)"; },
                transition: 'margin .2s',
                borderRadius: ARROW_GIRTH / 1.5 + "px",
            },
        },
    });
}, { name: 'Checkout_ButtonWithArrow' });
exports.default = buttonWithArrowStyles;
